import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar } from "@fortawesome/pro-regular-svg-icons"
import TernaryCell from "./TernaryCell"
import "react-tippy/dist/tippy.css"
import { Tooltip } from "react-tippy"
import { IconsContainer } from "./styles"
import moment from "moment-timezone"

const InvoiceStatusCell = ({
  value,
  row: {
    original: { due_date }
  }
}) => {
  if (value == false && !!due_date) {
    const dueDateStr = moment(due_date).format("DD MMMM YYYY")

    return (
      <Tooltip title={`Payment due: ${dueDateStr}`}>
        <IconsContainer>
          <TernaryCell value={value} />
          <FontAwesomeIcon icon={faCalendar} size="sm" />
        </IconsContainer>
      </Tooltip>
    )
  } else {
    return <TernaryCell value={value} />
  }
}

export default InvoiceStatusCell
